import {Link, Stack, Typography} from '@mui/material';
import React from 'react';

import {translations} from 'presentation/translations-new';

import {AlertNdi} from 'presentation/components/AlertNdi';
import {PageAlertVariantEnum} from 'presentation/components/AlertNdi/constants';
import {LinksNdiSp} from 'presentation/constants/linksNdiEnum';
import {LinksNotredame} from 'presentation/constants/linksNotredameEnum';
import Icon from 'presentation/icons';
import {useHostName} from 'presentation/hooks';

const {ndiAlert, ndiAlertLinks} = translations['pt-br'].privateFlow.examResults;

export function NdiExamHistoryAlert() {
	const {isNotredameSaude} = useHostName();
	const linksEnum = isNotredameSaude ? LinksNotredame : LinksNdiSp;

	return (
		<AlertNdi
			variant={PageAlertVariantEnum.COLLAPSED}
			message={
				<Typography variant="body2">
					{ndiAlert.line1}
					<b>{ndiAlert.line2}</b>
					{ndiAlert.line3}
				</Typography>
			}
			description={
				<Stack gap={'16px'}>
					<Link
						onClick={() => window.open(linksEnum.EXAMS_SP, '_blank')}
						variant="body2"
						color="primary.main"
						sx={{cursor: 'pointer'}}>
						<Typography fontSize={14} component="span">
							{ndiAlertLinks.portalSp}
							<Icon
								name="external-link-default"
								size={16}
								style={{
									marginBottom: '-4px',
									marginLeft: '4px',
								}}
							/>
						</Typography>
					</Link>
					<Link
						onClick={() => window.open(linksEnum.EXAMS_RJ, '_blank')}
						variant="body2"
						color="primary.main"
						sx={{cursor: 'pointer'}}>
						<Typography fontSize={14} component="span">
							{ndiAlertLinks.portalRj}
							<Icon
								name="external-link-default"
								size={16}
								style={{
									marginBottom: '-4px',
									marginLeft: '4px',
								}}
							/>
						</Typography>
					</Link>
				</Stack>
			}
			marginBottom="8px"
		/>
	);
}
